module.exports = __webpack_public_path__ + "static/img/pic_log_logo.dfd90635.png";